import { render, staticRenderFns } from "./OrdenTrabajoCard.vue?vue&type=template&id=27e55385&scoped=true&"
import script from "./OrdenTrabajoCard.vue?vue&type=script&lang=js&"
export * from "./OrdenTrabajoCard.vue?vue&type=script&lang=js&"
import style0 from "./OrdenTrabajoCard.vue?vue&type=style&index=0&id=27e55385&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e55385",
  null
  
)

export default component.exports